<template>
  <div class='dialog_menu search_menu' :class='{slide_in_right: show, show_result: isResult}'>
    <div class='top'>
      <div class='fz_0 text_center'>
        <div class='icon icon_goods_search'></div>
        <input v-model='inputValue' type='text' placeholder='分销商授权码/名称' class='dis_ib'>
        <div class='more' @click='searchAuthorize'>{{ inputValue.length ? '搜索' : '取消' }}</div>
      </div>
    </div>
    <div class='line'></div>
    <div v-if='!detail.name && search' class='rel1'>
      <p>该分销商不存在</p>
      <img :src='illBook2' width='250' height='500' alt='' class='img'>
    </div>
    <div v-if='search && detail.name' class='rel2 pos_r'>
      <img :src='illStar' width='650' alt='' class='bg'>
      <div class='tit text_left'>搜索结果：</div>
      <div class='rel_info'>
        <h4 class='text_center'>
          <img :src='illAuthorizationUp' width='97' alt=''>
          <p>{{ detail.name }}</p>
          <img :src='illAuthorizationDown' width='97' alt=''>
        </h4>
        <ul>
          <li>公司名称：<span class='fw600'>{{ detail.name }}</span></li>
          <li>授权日期：<span class='fw600'>{{ detail.date }}</span></li>
          <li>授权编号：<span class='fw600'>{{ detail.number }}</span></li>
          <li>业务范围：<span class='fw600'>{{ detail.scope }}</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import illBook2 from '@/assets/icons/ill_book2@2x.png'
import illStar from '@/assets/icons/ill_star@2x.png'
import illAuthorizationUp from '@/assets/icons/ill_authorization_up@2x.png'
import illAuthorizationDown from '@/assets/icons/ill_authorization_down@2x.png'

export default {
  name: 'AuthorizeSearchMenu',
  props: ['detail', 'search', 'keyWord', 'show'],
  data () {
    return {
      inputValue: this.keyWord,
      illBook2,
      illStar,
      illAuthorizationUp,
      illAuthorizationDown,
      isResult: false,
    }
  },
  components: {},
  methods: {
    close () {
      this.isResult = false
      this.$emit('close')
    },
    searchAuthorize () {
      if (!this.inputValue.length) {
        this.close()
        return
      }
      this.isResult = true
      this.$emit('searchAuthorize', this.inputValue)
    },
  },
}
</script>
